module.exports = __webpack_public_path__ + "public/images/slider/filimonova-circle.e3f44fb06acf0f10af6e4d5818b21fd8.webp";